module.exports = __webpack_public_path__ + "img/crew_group.ed59e8a0.jpg";